module.exports = __webpack_public_path__ + "img/classroom.5d4541f9.svg";